import React from "react";

import { Hint, LabelText, Row, Text, Thumb, Track } from "./styles";

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    // Без подписи тумблер остаётся без доступного имени, поэтому тогда обязателен
    // ariaLabel: состояние видно глазами, но не скринридеру.
    label?: React.ReactNode;
    ariaLabel?: string;
    hint?: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

export const ToggleSwitch = ({
    checked,
    onChange,
    label,
    ariaLabel,
    hint,
    disabled,
    className,
}: ToggleSwitchProps) => {
    const toggle = () => {
        if (disabled) return;
        onChange(!checked);
    };

    return (
        <Row className={className} $disabled={disabled}>
            <Track
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={ariaLabel}
                disabled={disabled}
                $checked={checked}
                onClick={toggle}
            >
                <Thumb $checked={checked} />
            </Track>
            {/* Клик по подписи тоже переключает — привычное поведение строки настройки. */}
            {(label || hint) && (
                <Text $disabled={disabled} onClick={toggle}>
                    {label && <LabelText>{label}</LabelText>}
                    {hint && <Hint>{hint}</Hint>}
                </Text>
            )}
        </Row>
    );
};
